import React, {useState} from 'react';
import { jwtDecode } from 'jwt-decode'
import PropTypes from "prop-types";

import './UsernamePasswordLogin.css';
import {TextField} from '@mui/material'
import Button from '@mui/material/Button'

function UsernamePasswordLogin({onSuccessfulLogin}) {
    const [username, setUserName] = useState();
    const [password, setPassword] = useState();

    const apiUrl = window.RUNTIME_CONFIG.REACT_APP_API_URL;

    async function loginUser(strJson) {
        const fullUrl = `${apiUrl}/authenticate`;
        console.log(" fullURL: " + fullUrl);

        return fetch(fullUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: strJson
        }).then(data => data.json());
    }

    const handleSubmit = async e => {
        e.preventDefault();

        var credentials = {
            "username": username,
            "password": password
        }

        var strJson = JSON.stringify(credentials)

        const response = await loginUser(strJson);
        const user = jwtDecode(response.accessToken)

        localStorage.setItem('accessToken', response.accessToken);
        localStorage.setItem('refreshToken', response.refreshToken);

        onSuccessfulLogin(user);
    }

    return (
        <div className="username-password-login-wrapper">
            <h1 className="text-center">Login</h1>
            <form onSubmit={handleSubmit} className="username-password-login">
                <TextField
                  id="username"
                  label="Username"
                  variant="outlined"
                  fullWidth
                  sx={{
                      marginBottom: '2rem'
                  }}
                  onChange={e => setUserName(e.target.value)}
                />
                <TextField
                  id="password"
                  type="password"
                  label="Password"
                  variant="outlined"
                  fullWidth
                  sx={{
                      marginBottom: '2rem'
                  }}
                  onChange={e => setPassword(e.target.value)}
                />
                <div className="text-center">
                    <Button variant="contained" type="submit">Login</Button>
                </div>
            </form>
        </div>
    )
}

UsernamePasswordLogin.propTypes = {
    onSuccessfulLogin: PropTypes.func.isRequired
}

export default UsernamePasswordLogin;
